var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-button",class:{borderTop:_vm.borderTop}},[(_vm.title)?_c('p',{staticClass:"title-button_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"title-button_tabs"},[_vm._t("tabs")],2),_c('div',{staticClass:"title-button_content"},[_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }